/* eslint-disable max-lines-per-function */
import React from 'react'
import PropTypes from 'prop-types'
import xss from 'xss'
import { BiLinkExternal } from 'react-icons/bi'
import { isPresent, isBlankOrZero } from '/src/utils/boolean_refinements'
import '/src/static/css/inputs.css'

export default function InputFormulaLink({ inputProps })  {
  const { id, name, placeholder, formula_result: value } = inputProps

  const formatLink = (val) => {
    let actualLink = val
    if (val.includes("</a>")) {
      const el = document.createElement('div')
      el.innerHTML = xss(actualLink)
      actualLink = (el.firstChild && el.firstChild.href) ? el.firstChild.href : '#'
    }

    return actualLink
  }

  const formatValue = (val) => {
    let actualValue = val
    if (val.includes("</a>")) {
      const el = document.createElement('div')
      el.innerHTML = xss(actualValue)
      actualValue = el.textContent
    }

    return actualValue
  }

  return (
    <React.Fragment>
      <div className="formula-wrapper input-type-link">
        <input
          id={id}
          className="form-input-text"
          name={name}
          value={!isBlankOrZero(value) ? formatValue(value) : ''}
          disabled
          placeholder={placeholder}
          type="text"
        />
        <a
          href={!isBlankOrZero(value) ? formatLink(value) : ''}
          target="_blank"
          rel="noopener noreferrer"
        >
          <BiLinkExternal />
        </a>
      </div>
    </React.Fragment>
  )
}

InputFormulaLink.propTypes = {
  inputProps: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
  }).isRequired
}
